module.exports = {"511521100":"柏溪镇","511521101":"喜捷镇","511521102":"观音镇","511521103":"横江镇","511521104":"永兴镇","511521105":"白花镇","511521106":"柳嘉镇","511521107":"泥溪镇","511521108":"蕨溪镇","511521109":"商州镇","511521110":"高场镇","511521111":"安边镇","511521112":"双龙镇","511521113":"李场镇","511521114":"合什镇","511521115":"古罗镇","511521116":"孔滩镇","511521117":"复龙镇","511521118":"普安镇","511521119":"双谊镇","511521120":"古柏镇","511521121":"王场镇","511521122":"泥南镇","511521203":"隆兴乡","511521205":"龙池乡","511521209":"凤仪乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511521.json
// module id = 2358
// module chunks = 0